module.exports = __webpack_public_path__ + "static/media/loader.2aef78bd.png";